'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Component: Auto Redirect & Store Switch script
 * ------------------------------------------------------------------------------
 * An example file that contains scripts to function.
 *
 * @namespace autoRedirect
 */

/**
 * Create a new example object.
 * @param {object} config - Settings object defined when instantiating.
 */

/**
 * DOM selectors.
 */
var selectors = {
  storeSelector: '[js-auto-redirect="selector"]'
};

exports.default = function (config) {

  /**
   * Instance settings.
   */
  var settings = {
    enableStoreSwitch: theme.store.storeSwitch,
    enableAutoRedirect: theme.store.autoRedirect
  };

  /**
   * DOM node selectors.
   */
  var nodeSelectors = {
    storeSelector: document.querySelector(selectors.storeSelector)
  };

  function handleRedirect(countryCode) {
    var caURL = 'https://ca.34heritage.com';
    var usURL = 'https://34heritage.com';
    var autoRedirectedKey = '34_heritage_auto_redirected';
    var storeCountryCode = theme.store.countryCode;
    var autoRedirected = sessionStorage.getItem(autoRedirectedKey);
    var rowIP = void 0;

    if (countryCode !== 'US' && countryCode !== 'CA') {
      rowIP = true;
    } else {
      rowIP = false;
    }

    if (countryCode === storeCountryCode || autoRedirected === true) {
      // Do nothing
    } else if (rowIP === true && storeCountryCode === 'US') {
      // Do nothing
    } else if (countryCode !== storeCountryCode && countryCode === 'CA') {
      window.top.location.href = caURL;
    } else {
      window.top.location.href = usURL;
      sessionStorage.setItem(autoRedirectedKey, true);
    }
  }

  function updateDisplay(countryCode) {
    if (countryCode === 'US') {
      nodeSelectors.storeSelector.value = 'US';
    } else if (countryCode === 'CA') {
      nodeSelectors.storeSelector.value = 'CA';
    }
  }

  function getUserCountryCode() {
    var accessKey = '759016defa3b2c47fd6e9040ddb3e81c';
    jQuery.ajax({
      url: 'https://api.ipstack.com/check?access_key=' + accessKey,
      dataType: 'jsonp',
      success: function success(json) {
        if (settings.enableAutoRedirect) {
          handleRedirect(json.country_code);
        }
      }
    });
  }

  /**
   * Initialise component.
   */
  function init() {
    getUserCountryCode();
    if (settings.enableStoreSwitch) {
      updateDisplay(theme.store.countryCode);
      setTriggerEvents();
    }
  }

  /**
   * Set trigger listeners.
   */
  function setTriggerEvents() {
    nodeSelectors.storeSelector.onchange = function () {
      handleRedirect(this.value);
    };
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init: init
  });
};